import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutViewServiceService {

  private _isView = new BehaviorSubject<boolean>(false);

  isView$ = this._isView.asObservable();

  setIsView(value: boolean) {
      this._isView.next(value);
  }
}
